import * as React from 'react';
import { CustomButton, ButtonType, ModalBody, Modal, ModalSize, ModalFooter, CustomSubmitButton } from "soprasteria-ui-library";
import { useAuth } from '../../../../App';
import { OrthodonticReferralAdministrationApi } from "../../../../api/OrthodonticReferralAdministrationApi";

interface IOrthodonticReferralWithdrawButton {
    orthodonticReferralId: number;
    changeSuccessMessage: (message: string) => void;
    changeErrorMessage: (message: string) => void;
    getOrthodonticReferral: (id: number) => void;
}

export const OrthodonticReferralWithdrawButton: React.FunctionComponent<IOrthodonticReferralWithdrawButton> = ({ changeSuccessMessage, changeErrorMessage, getOrthodonticReferral, orthodonticReferralId }) => {
    const auth = useAuth();
    const api = new OrthodonticReferralAdministrationApi(auth);
    const [isWithdrawing, setIsWithdrawing] = React.useState<boolean>(false);

    const withDrawOrthodonticReferral = () => {
        setIsWithdrawing(true);
        api.withdrawOrthodonticReferral(orthodonticReferralId,
            () => {
                document.getElementById("close-withdraw-orthodontic-referral-modal")?.click();
                getOrthodonticReferral(orthodonticReferralId);
                changeSuccessMessage("Ortodontiremissen har återkallats");
            },
            (error) => {
                changeErrorMessage(error);
            },
            () => {
                setIsWithdrawing(false);
            })
    }

    return (
        <>
            <CustomButton buttonType={ButtonType.deleteAlt} buttonText="Återkalla ortodontiremiss" data-toggle="modal" data-target="#withdraw-orthodontic-referral-modal" />
            <Modal header="Återkalla ortodontiremiss" id="withdraw-orthodontic-referral-modal" modalSize={ModalSize.normal}>
                <ModalBody>
                    <p>Du har valt att återkalla remissen, ingen bedömning av patienten kommer att ske. Är du säker på att du vill återkalla ortodontiremissen?</p>
                </ModalBody>
                <ModalFooter>
                    <CustomButton buttonType={ButtonType.general} buttonText="Nej" data-dismiss="modal" id="close-withdraw-orthodontic-referral-modal" />
                    <CustomSubmitButton onButtonSubmit={withDrawOrthodonticReferral} isLoading={isWithdrawing}>Ja</CustomSubmitButton>
                </ModalFooter>
            </Modal>
        </>
    )
}